import { EXPIRATION_LEAD_TIME_SECONDS } from "../auth/userServices";
import { useAppSelector } from "../store/hooks";
import { isQueryServicePortalEnabled } from "../utils/authUtils";
import { useIsAdminUser } from "./useIsAdminUser";
import { useIsUserAuthenticated } from "./useIsUserAuthenticated";

export const useIsQueryPortalUser = () => {
  const hasQuerySettings: boolean = useAppSelector((state) =>
    isQueryServicePortalEnabled(state.auth)
  );
  const isUserAuthenticated = useIsUserAuthenticated();
  const isAdmin = useIsAdminUser();

  return (includeAdmin: boolean = true): boolean => {
    return (
      (isUserAuthenticated() && hasQuerySettings) || (includeAdmin && isAdmin())
    );
  };
};
